// @flow
'use strict';

var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gud/index.js
// module id = 2661
// module chunks = 168707334958949